"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactHeadroom = _interopRequireDefault(require("react-headroom"));

var _reactRedux = require("react-redux");

var _reactstrap = require("reactstrap");

var _reactRouterDom = require("react-router-dom");

var _config = _interopRequireDefault(require("@dom/config"));

var _auth = require("@dom/app/src/actions/auth");

var _NavbarMobile = _interopRequireDefault(require("./NavbarMobile"));

var _NavbarDesktop = _interopRequireDefault(require("./NavbarDesktop"));

var _ResponsiveScreens = require("../ResponsiveScreens");

var _CartIcon = _interopRequireDefault(require("./Cart/CartIcon"));

require("./nav.scss");

var fallbackUserAvatar = 'https://s3.amazonaws.com/honeyguide/assets/user-fallback.png';
var socialMediaLinks = [{
  text: 'facebook',
  link: 'https://www.facebook.com/honeyguideapp/'
}, {
  text: 'instagram',
  link: 'https://www.instagram.com/honeyguideapps/'
}, {
  text: 'youtube',
  link: 'https://youtube.com/honeyguideapps'
}, {
  text: 'whatsapp',
  link: 'https://api.whatsapp.com/send?phone=+977-9803759639'
}, {
  text: 'viber',
  link: 'https://viber.com/+Honeyguideapps'
}];

function NavBar(props) {
  var openLoginModal = props.openLoginModal,
      openSignUpModal = props.openSignUpModal,
      userInfo = props.userInfo;
  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_ResponsiveScreens.DesktopScreen, null, _react["default"].createElement(_reactHeadroom["default"], {
    upTolerance: 0,
    downTolerance: 2
  }, _react["default"].createElement("div", {
    className: "top-contact"
  }, _react["default"].createElement("div", {
    className: "container topbar-container"
  }, _react["default"].createElement("div", {
    className: "social-bar"
  }, _react["default"].createElement("ul", null, socialMediaLinks.map(function (_ref) {
    var text = _ref.text,
        link = _ref.link;
    return _react["default"].createElement("li", {
      key: text
    }, _react["default"].createElement("a", {
      href: link
    }, _react["default"].createElement("img", {
      src: "https://s3.amazonaws.com/honeyguide/assets/icons/".concat(text, ".png"),
      alt: text
    })));
  })), _react["default"].createElement("ul", {
    className: "contact-cta"
  }, _react["default"].createElement("li", null, _react["default"].createElement("a", {
    href: "tel:".concat(_config["default"].honeyguidePhoneNumber)
  }, _react["default"].createElement("img", {
    src: "https://s3.amazonaws.com/honeyguide/assets/icons/phone.png",
    alt: ""
  }), _react["default"].createElement("span", {
    className: "d-none d-lg-inline"
  }, _config["default"].honeyguidePhoneNumber))), _react["default"].createElement("li", null, _react["default"].createElement("a", {
    href: "mailto:".concat(_config["default"].honeyguideEmail)
  }, _react["default"].createElement("img", {
    src: "https://s3.amazonaws.com/honeyguide/assets/icons/mail.png",
    alt: ""
  }), _react["default"].createElement("span", {
    className: "d-none d-lg-inline"
  }, _config["default"].honeyguideEmail))))), _react["default"].createElement("div", {
    className: "action-bar"
  }, _react["default"].createElement(_CartIcon["default"], null), !userInfo && _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_reactstrap.Button, {
    color: "toplogin",
    size: "sm",
    onClick: openLoginModal
  }, "Log in"), _react["default"].createElement(_reactstrap.Button, {
    color: "topsignup",
    size: "sm",
    onClick: openSignUpModal
  }, "Sign up"))))), _react["default"].createElement(_NavbarDesktop["default"], props))), _react["default"].createElement(_ResponsiveScreens.MobileScreen, null, _react["default"].createElement(_reactHeadroom["default"], null, _react["default"].createElement("div", {
    className: "top-contact"
  }, _react["default"].createElement("div", {
    className: "container topbar-container"
  }, _react["default"].createElement("div", {
    className: "social-bar"
  }, _react["default"].createElement("ul", null, socialMediaLinks.map(function (_ref2) {
    var text = _ref2.text,
        link = _ref2.link;
    return _react["default"].createElement("li", {
      key: text
    }, _react["default"].createElement("a", {
      href: link
    }, _react["default"].createElement("img", {
      src: "https://s3.amazonaws.com/honeyguide/assets/icons/".concat(text, ".png"),
      alt: text
    })));
  })), _react["default"].createElement("ul", {
    className: "contact-cta"
  }, _react["default"].createElement("li", null, _react["default"].createElement("a", {
    href: "tel:".concat(_config["default"].honeyguidePhoneNumber)
  }, _react["default"].createElement("img", {
    src: "https://s3.amazonaws.com/honeyguide/assets/icons/phone.png",
    alt: ""
  }), _react["default"].createElement("span", {
    className: "d-none d-lg-inline"
  }, _config["default"].honeyguidePhoneNumber))), _react["default"].createElement("li", null, _react["default"].createElement("a", {
    href: "mailto:".concat(_config["default"].honeyguideEmail)
  }, _react["default"].createElement("img", {
    src: "https://s3.amazonaws.com/honeyguide/assets/icons/mail.png",
    alt: ""
  }), _react["default"].createElement("span", {
    className: "d-none d-lg-inline"
  }, _config["default"].honeyguideEmail))))), _react["default"].createElement("div", {
    className: "action-bar"
  }, _react["default"].createElement(_CartIcon["default"], null)))), _react["default"].createElement(_NavbarMobile["default"], props))));
}

var mapStateToProps = function mapStateToProps(_ref3) {
  var user = _ref3.user;
  return {
    userInfo: user.userId ? {
      image: user.avatar ? "".concat(_config["default"].RESOURCE_URL, "/").concat(user.avatar) : fallbackUserAvatar,
      userId: user.userId,
      name: user.name
    } : null
  };
};

var mapActionToProps = {
  logout: _auth.logout,
  openLoginModal: _auth.openLoginModal,
  openSignUpModal: _auth.openSignUpModal
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapActionToProps)(NavBar));

exports["default"] = _default;